console.log("🔥 LOCATION JS CARGADO");

function updateCheckoutState() {

  const btn = document.querySelector('button[name="checkout"]');
  if (!btn) return;

  const saved = localStorage.getItem("customer_location");

  // 🔥 SI NO HAY UBICACIÓN → BLOQUEAR
  if (!saved) {
    btn.disabled = true;
    btn.style.opacity = "0.5";
    btn.style.pointerEvents = "none";

    console.log("🚫 Checkout bloqueado (sin ubicación)");
  }

  // ✅ SI HAY → PERMITIR
  else {
    btn.disabled = false;
    btn.style.opacity = "1";
    btn.style.pointerEvents = "auto";

    console.log("✅ Checkout habilitado");
  }
}

function updateLocationButton() {
  const btn = document.getElementById("openLocationModalBtn");
  if (!btn) return;

  const saved = localStorage.getItem("customer_location");

  if (saved) {
    btn.textContent = "📍 Cambiar ubicación de envío";
    btn.classList.add("location-set");
  } else {
    btn.textContent = "📍 Agregar ubicación de envío";
    btn.classList.remove("location-set");
  }
}

function updateSavedAddressUI() {
  const data = JSON.parse(localStorage.getItem("customer_location"));
  if (!data || !data.address) return;

  // 🔥 actualizar texto
  const elements = document.querySelectorAll("#savedAddressText");

  elements.forEach(el => {
    el.textContent = `📍 ${data.address}`;
  });

  // 🔥 asegurar que el mensaje esté visible
  const savedMsg = document.querySelectorAll("#locationSavedMessage");

  savedMsg.forEach(el => {
    el.classList.add("active");
  });

  console.log("📍 UI actualizada:", data.address);
}

// ===============================
// 📍 LOCATION MODULE (MAPA)
// ===============================

let map;
let marker;
let autocomplete;
let mapReady = false;

// ===============================
// 🗺️ INICIALIZAR MAPA (FIX PRO)
// ===============================

// 🔥 Esperar Google Maps correctamente
function waitForGoogleMaps(callback) {
  const interval = setInterval(() => {
    if (window.google && window.google.maps && window.google.maps.places) {
      clearInterval(interval);
      callback();
    }
  }, 100);
}

function waitForMapContainer() {
  setTimeout(() => {
    initMap();

    if (map && marker) {
      google.maps.event.trigger(map, "resize");
      map.setCenter(marker.getPosition());
    }
  }, 300);
}

function initMap() {

  if (mapReady) {
    const mapEl = document.getElementById('map');
    if (mapEl) {
      mapEl.classList.remove("loading");
    }
    return;
  }

  waitForGoogleMaps(() => {

    const mapEl = document.getElementById('map');
    const input = document.getElementById('mapSearch');

    if (!mapEl || !input) {
      console.warn("❌ Map o input no listos aún");
      return;
    }

    navigator.geolocation.getCurrentPosition((pos) => {
      buildMap({
        lat: pos.coords.latitude,
        lng: pos.coords.longitude
      });
    }, () => {
      buildMap({ lat: 14.0723, lng: -87.1921 }); // fallback Tegus
    });

  });

}

// ===============================
// 🧱 CREAR MAPA
// ===============================
function buildMap(center) {

  const mapEl = document.getElementById('map');
if (!mapEl) return;

mapEl.classList.add("loading");

// 🔥 LIMPIAR CONTENEDOR
mapEl.innerHTML = "";

  map = new google.maps.Map(document.getElementById('map'), {
    center,
    zoom: 15,
    gestureHandling: "greedy"
  });

  // 🔥 QUITAR LOADER CUANDO EL MAPA YA ESTÁ LISTO
google.maps.event.addListenerOnce(map, 'idle', () => {
  mapEl.classList.remove("loading");
});

  marker = new google.maps.Marker({
    position: center,
    map,
    draggable: true
  });

  const input = document.getElementById('mapSearch');
  if (!input) return;

  input.value = "";

  // 🔥 PROTEGER contra carga incompleta de Google
if (!window.google?.maps?.places) {
  console.error("❌ Places API no disponible aún");
  return;
}

// 🔥 EVITAR duplicados (Shopify re-render)
if (autocomplete) {
  console.log("♻️ Reutilizando autocomplete existente");
  return;
}

autocomplete = new google.maps.places.Autocomplete(input, {
  componentRestrictions: { country: "hn" },
  fields: ["geometry", "address_components", "formatted_address", "name"]
});

  autocomplete.bindTo("bounds", map);

  // 🔥 FORZAR activación del autocomplete siempre
input.addEventListener("focus", () => {
  input.dispatchEvent(new Event("input"));
});

  // 🔥 Mover dropdown correctamente (estable y sin timing roto)
const observer = new MutationObserver(() => {
  const pac = document.querySelector('.pac-container');
  const modalContent = document.querySelector('.location-modal__content');

  if (pac && modalContent && !modalContent.contains(pac)) {
    modalContent.appendChild(pac);
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

  autocomplete.addListener('place_changed', () => {
  const place = autocomplete.getPlace();

  if (!place.geometry || !place.geometry.location) {
    console.warn("❌ No geometry en place");
    return;
  }

  const location = place.geometry.location;

  // 🔥 mover mapa y pin SIEMPRE
  map.setCenter(location);
  marker.setPosition(location);

  // 🔥 usar la mejor dirección disponible
  let address = place.formatted_address;

  if (!address && place.name) {
    address = place.name;
  }

  saveLocation(location, address);
});

  marker.addListener('dragend', () => {
    saveLocation(marker.getPosition());
  });

  //saveLocation(marker.getPosition());

  setTimeout(() => {
  google.maps.event.trigger(map, "resize");
  map.setCenter(center);
}, 300);

  mapReady = true;
}

async function saveLocation(loc, address = null) {
  const lat = loc.lat();
  const lng = loc.lng();

  // ===============================
  // 🔥 OBTENER DIRECCIÓN REAL (GEOCODING)
  // ===============================
  if (!address && window.google) {
    try {
      const geocoder = new google.maps.Geocoder();

      const response = await geocoder.geocode({
        location: { lat, lng }
      });

      if (response.results && response.results.length > 0) {
        address = response.results[0].formatted_address;
      }
    } catch (err) {
      console.error("❌ Error obteniendo dirección:", err);
    }
  }

  const data = {
    lat,
    lng,
    address: address || "Ubicación seleccionada",
    googleMapsUrl: `https://www.google.com/maps?q=${lat},${lng}`
  };

  // 💾 guardar
  localStorage.setItem("customer_location", JSON.stringify(data));

  // ===============================
// 📦 ENVIAR UBICACIÓN AL PEDIDO
// ===============================
try {
  await fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      attributes: {
        "📍 Dirección": data.address,
        "🗺️ Google Maps": data.googleMapsUrl
      }
    })
  });

  console.log("📦 Ubicación enviada al carrito");
} catch (err) {
  console.error("❌ Error enviando ubicación:", err);
}

  // 🔄 actualizar UI
  updateLocationButton();
  updateSavedAddressUI();

  // 🚚 shipping
  try {
    await window.Shipping.applyShippingLogic();
  } catch (err) {
    console.error("❌ Error en shipping:", err);
  }

  console.log("📍 Ubicación guardada:", data);
}


// ===============================
// 🎯 EVENTOS
// ===============================
function bindLocationButton() {
  const btn = document.getElementById("openLocationModalBtn");

  if (!btn) {
    setTimeout(bindLocationButton, 400);
    return;
  }

  console.log("✅ BOTÓN LISTO");

  // 🔥 ACTUALIZAR TEXTO DINÁMICO (NUEVO)
  updateLocationButton();

  // 🔥 EVITAR EVENTOS DUPLICADOS (CRÍTICO EN SHOPIFY)
  if (btn.dataset.bound === "true") return;

btn.dataset.bound = "true";

btn.addEventListener("click", () => {
    console.log("🔥 CLICK REAL FUNCIONANDO");

    const modal = document.getElementById("locationModal");

    if (!modal) {
      console.error("❌ MODAL NO EXISTE");
      return;
    }

    modal.showModal();

    const modalBody = document.getElementById("locationModalBody");
    const mapContainer = document.querySelector(".cart-map-side");

    if (modalBody && mapContainer) {
      modalBody.appendChild(mapContainer);
    }

    const mapEl = document.getElementById('map');

    // 🔥 SOLO mostrar loader si el mapa NO está listo
    if (mapEl && !mapReady) {
      mapEl.classList.add("loading");
    }

    setTimeout(() => {
      initMap();
    }, 300);

    updateCheckoutState();
  });
}


// 💾 GUARDAR UBICACIÓN
document.addEventListener("click", (e) => {

  const saveBtn = e.target.closest("#saveLocationBtn");
  if (!saveBtn) return;

  if (!marker) return;

  const modal = document.getElementById("locationModal");

  const position = marker.getPosition();
  saveLocation(position);
  // ✅ MOSTRAR MENSAJE EN CARRITO
const savedMsg = document.getElementById("locationSavedMessage");
const addressText = document.getElementById("savedAddressText");

if (savedMsg) {
  savedMsg.classList.add("active");
}

updateSavedAddressUI();

  updateCheckoutState();

  // 🎉 ANIMACIÓN UBICACIÓN GUARDADA (ANTES DE CERRAR)
  setTimeout(() => {
    const success = document.getElementById("locationSuccess");

    if (success) {
      success.classList.add("active");

      setTimeout(() => {
        success.classList.remove("active");
      }, 2000);
    } else {
      console.log("❌ No existe locationSuccess");
    }
  }, 100);

  // cerrar modal después de mostrar animación
  setTimeout(() => {
    if (modal) modal.close();
  }, 1200);

  // 🔥 SHIPPING
  if (window.Shipping) {
    setTimeout(() => {
      window.Shipping.applyShippingLogic();
    }, 500);
  }

  console.log("✅ Ubicación confirmada");
});

// 🔒 BLOQUEAR SI NO HAY UBICACIÓN
// 🔥 SINCRONIZAR SIEMPRE (SHOPIFY FIX)

// ===============================
// ❌ CERRAR MODAL (BOTÓN X REAL)
// ===============================

document.addEventListener("click", (e) => {

  const modal = document.getElementById("locationModal");
  if (!modal || !modal.open) return;

  // 🔍 Detectar click en botón tipo "X"
  const closeBtn = e.target.closest("button");

  if (!closeBtn) return;

  // 🔥 IMPORTANTE: asegurarnos que sea el botón de cerrar
  const isCloseButton =
    closeBtn.closest(".location-modal") && // está dentro del modal
    !closeBtn.closest("#saveLocationBtn") && // no es guardar
    !closeBtn.closest("#openLocationModalBtn"); // no es abrir

  if (!isCloseButton) return;

  // ❌ cerrar modal
  modal.close();

  // 🔄 devolver mapa a su lugar original
  const mapContainer = document.querySelector(".cart-map-side");
  const originalParent = document.querySelector(".cart-content-side");

  if (originalParent && mapContainer) {
    originalParent.prepend(mapContainer);
  }

  console.log("❌ Modal cerrado desde X");
});

// cada interacción (por si Shopify reconstruye DOM)
document.addEventListener("click", () => {
  setTimeout(() => {
    updateCheckoutState();
    bindLocationButton();
  }, 300);

  // 🔥 ejecutar un poco después (cuando Shopify ya renderizó)
  setTimeout(() => {
    updateSavedAddressUI();
  }, 600);
});

// ===============================
// 🔥 EVENT DELEGATION (BOTÓN MODAL)
// ===============================

// ❌ DESACTIVADO TEMPORALMENTE (causaba conflicto con bindLocationButton)
/*
document.addEventListener("click", (e) => {

  const btn = e.target.closest("#openLocationModalBtn");
  if (!btn) return;

  console.log("🔥 CLICK MODAL NATURAL");

  const modal = document.getElementById("locationModal");

  if (!modal) {
    console.error("❌ MODAL NO EXISTE");
    return;
  }

  modal.showModal();

  const modalBody = document.getElementById("locationModalBody");
  const mapContainer = document.querySelector(".cart-map-side");

  if (modalBody && mapContainer) {
    modalBody.appendChild(mapContainer);
  }

  const mapEl = document.getElementById('map');

  if (mapEl && !mapReady) {
    mapEl.classList.add("loading");
  }

  setTimeout(() => {
    initMap();
  }, 300);

  updateCheckoutState();
});
*/

function initLocationState() {

  console.log("🔄 Inicializando estado location...");

  const saved = localStorage.getItem("customer_location");

  // 🧹 SI NO HAY UBICACIÓN → RESET UI
  if (!saved) {

    console.log("🧹 Reset UI sin ubicación");

    const addressElements = document.querySelectorAll("#savedAddressText");

    addressElements.forEach(el => {
      el.textContent = "📍 Ubicación seleccionada";
    });

  }

  // 🔄 SI HAY → RESTAURAR TODO
  else {

    console.log("📍 Restaurando ubicación guardada");

    updateSavedAddressUI();

    // 🔥 recalcular envío automáticamente
    if (window.Shipping && window.Shipping.applyShippingLogic) {
      setTimeout(() => {
        window.Shipping.applyShippingLogic();
      }, 300);
    }
  }

  updateLocationButton();
  updateCheckoutState();
  bindLocationButton();
}

// 🔥 DOM READY
document.addEventListener("DOMContentLoaded", initLocationState);

// 🔥 SHOPIFY RE-RENDER (CLAVE)
document.addEventListener("shopify:section:load", initLocationState);

// 🔥 fallback extra
setTimeout(initLocationState, 500);
